import { useLang } from "@/context/LanguageContext";
import { LANGS } from "@/i18n/translations";
import { Globe } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher({ tone = "dark" }) {
    const { lang, setLang } = useLang();
    const current = LANGS.find((l) => l.code === lang) || LANGS[0];

    const triggerCls =
        tone === "light"
            ? "inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-xs font-semibold text-white hover:bg-white/10 transition"
            : "inline-flex items-center gap-2 rounded-full border border-black/10 bg-white px-3 py-1.5 text-xs font-semibold text-brand-charcoal hover:border-brand-charcoal/40 transition";

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button data-testid="language-switcher" className={triggerCls} aria-label="Sprache wählen">
                    <Globe className="h-3.5 w-3.5" />
                    <span>{current.label}</span>
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-[160px]">
                {LANGS.map((l) => (
                    <DropdownMenuItem
                        key={l.code}
                        data-testid={`lang-option-${l.code}`}
                        onClick={() => setLang(l.code)}
                        className={l.code === lang ? "font-semibold" : ""}
                    >
                        <span className="mr-2 font-mono text-xs">{l.label}</span>
                        {l.name}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
